/**
 * Centralized configuration for API endpoints that require Segment anonymousId header.
 */
/**
 * Helper function to get Segment anonymousId for API headers
 * Returns null if trackingFactory is not available
 */
export async function getSegmentAnonymousId() {
    try {
        const { getAngularService, AngularServices } = await import('../../modules/core/helpers/get-angular-service');
        const trackingFactory = getAngularService(AngularServices.TrackingFactory);
        if (trackingFactory?.segment != null &&
            typeof trackingFactory.segment.getAnonymousId === 'function') {
            return trackingFactory.segment.getAnonymousId();
        }
        return null;
    }
    catch {
        // Silently fail if trackingfactory is not available
        return null;
    }
}
/**
 * Helper function to add Segment anonymousId header to headers object
 * Modifies headers in place
 */
export async function addSegmentHeader(headers) {
    try {
        const anonymousId = await getSegmentAnonymousId();
        if (anonymousId) {
            headers['x-segment-anonymous-id'] = anonymousId;
        }
    }
    catch {
        // Silently fail
    }
}
/**
 * List of endpoints that should include the x-segment-anonymous-id header
 */
export const SEGMENT_ANONYMOUS_ID_ENDPOINTS = [
    { path: '/api/users/login', method: 'POST', exact: false },
    { path: '/api/users', method: 'POST', exact: false },
    { path: '/users/', method: 'PUT', exact: false }, // Identify for User Profile Update
];
/**
 * Check if an endpoint should include the Segment anonymousId header
 * @param url - The request URL
 * @param method - The HTTP method
 * @returns true if the endpoint should include the header
 */
export function shouldIncludeSegmentAnonymousId(url, method) {
    if (!url || !method) {
        return false;
    }
    return SEGMENT_ANONYMOUS_ID_ENDPOINTS.some((config) => {
        if (config.method !== method.toUpperCase()) {
            return false;
        }
        if (config.exact) {
            return url === config.path || url.endsWith(config.path);
        }
        return (url.includes(`${config.path}/`) ||
            url.includes(`${config.path}?`) ||
            url.endsWith(config.path));
    });
}
